import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaInstagram, FaLinkedin, FaEnvelope, FaShieldAlt, FaTimesCircle, FaUndoAlt } from 'react-icons/fa';
import logo from './images/Codingboss-logo-1.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer border-top">
      <Container>
        <Row className="gy-4 py-4">
          {/* Brand & Mission */}
          <Col lg={4} md={6} className="text-start">
            <div className="d-flex align-items-center gap-2 mb-3">
              <img src={logo} alt="CodingBoss Logo" style={{ height: '36px' }} />
              <h5 className="mb-0 fw-bold text-dark">
                Coding<span style={{ color: '#FFA003' }}>Boss</span>
              </h5>
            </div>
            <p className="footer-desc text-muted mb-3" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
              Empowering developers and institutions with proctored college assessments, 
              interactive coding challenges, and career-accelerating curriculum.
            </p>
            <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>
              © {new Date().getFullYear()} <strong>CodingBoss</strong>. All rights reserved.
            </p>
          </Col>

          {/* Legal & Policies */}
          <Col lg={4} md={6} className="text-start ps-lg-5">
            <h6 className="footer-col-title fw-bold text-dark mb-3">Legal & Compliance</h6>
            <ul className="list-unstyled footer-links mb-0">
              <li className="mb-2">
                <Link to="/privacy-policy" className="footer-link d-inline-flex align-items-center gap-2">
                  <FaShieldAlt className="footer-icon-amber" /> Privacy Policy
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/cancellation-policy" className="footer-link d-inline-flex align-items-center gap-2">
                  <FaTimesCircle className="footer-icon-amber" /> Cancellation Policy
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/refund-policy" className="footer-link d-inline-flex align-items-center gap-2">
                  <FaUndoAlt className="footer-icon-amber" /> Refund Policy
                </Link>
              </li>
            </ul>
          </Col>

          {/* Contact & Socials */}
          <Col lg={4} md={12} className="text-start text-lg-end d-flex flex-column align-items-lg-end justify-content-start gap-2">
            <h6 className="footer-col-title fw-bold text-dark mb-3">Connect With Us</h6>
            <ContactItem 
              href="mailto:info@codingboss.com"
              label="info@codingboss.com"
              icon={<FaEnvelope />}
            />
            <ContactItem 
              href="https://instagram.com/codingboss_2.0"
              label="instagram.com/codingboss_2.0"
              icon={<FaInstagram />}
            />
            <ContactItem 
              href="https://linkedin.com/company/codingboss"
              label="linkedin.com/company/codingboss"
              icon={<FaLinkedin />}
            />                      
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
const ContactItem = ({ href, label, icon }) => (
  <a 
    href={href} 
    target={href.startsWith('http') ? "_blank" : undefined}
    rel={href.startsWith('http') ? "noopener noreferrer" : undefined}
    className="d-flex align-items-center gap-2 text-decoration-none text-light"
    aria-label={label}
  >
    <span>{label}</span>
    {icon}
  </a>
);
export default Footer;
